<template>
   <div>
      <div>
         <!-- Home page content -->
         <main role="main">
            <div class="container">
               <div class="text-center py-md-5 px-md-4 py-3">
                  <h1 class=" text-center text-pg-blue mb-3 brand-fontcolor" v-html="$t('Home.BannerTitle')">
                  </h1>
                  <p class="page-subheader m-0" v-html="$t('Home.BannerDesc')">
                  </p>
               </div>
               <div class="text-center readytosubmit">
                  <div class="row d-flex justify-content-between align-items-center">
                     <div class="col-sm-12 text-sm-center">
                        <h2 class="">{{ $t('Home.ReadytoSubmitTitle') }}</h2>
                        <p class="mt-3">
                           {{ $t('Home.ReadytoSubmitDesc') }}
                        </p>
                        <div class="col-sm-12">
                           <div class="mb-4">
                              <router-link to="/Upload" class="btn btn-link">  {{ $t('Home.GetStartedBtn') }}</router-link>
                           </div>
                        </div>
                     </div>
                  </div>
                  <p class="text-center m-0">
                     <small v-html="$t('Home.ParticipatingProductLink')"></small>   
                  </p>
                  <p class="text-center mb-4">
                     <small v-html="$t('Home.HavingTroubleLink')"></small> 
                  </p>
               </div>
            </div>
            <div class="htp-wrapper">
              <div class="container py-md-5 py-3">
                <h2 class="text-center mb-5"> {{ $t('Home.HowToParticipateTitle') }}</h2>
                <div class="row text-center d-flex justify-content-center">
                    <div class="col-md-6 col-lg-4 home-card-bg">
                      <div class="home-card">
                          <img
                            :src="$t('Home.ShopImg')"
                            alt="Shop"
                            class="img-fluid mb-3"
                            />
                          <h4>  {{ $t('Home.ShopTitle') }}</h4>
                          <p class="m-0" v-html="$t('Home.ShopDetail')">
                          </p>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4 home-card-bg">
                      <div class="home-card">
                          <img
                            :src="$t('Home.SnapImg')"
                            alt="Snap"
                            class="img-fluid mb-3"
                            />
                          <h4>  {{ $t('Home.SnapTitle') }}</h4>
                          <p class="m-0" v-html="$t('Home.SnapDetail')">
                          </p>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-4 home-card-bg">
                      <div class="home-card">
                          <img
                            :src="$t('Home.SendImg')"
                            alt="Send"
                            class="img-fluid mb-3"
                            />
                          <h4>  {{ $t('Home.SendTitle') }}</h4>
                          <p class="m-0" v-html="$t('Home.SendDetail')">
                          </p>
                      </div>
                    </div>
                  </div>
               </div>
            </div>            
         </main>
      </div>
   </div>
</template>
<script>
   export default {
     props: {
       startDate: {
         type: Date,
         required: true,
       },
       endDate: {
         type: Date,
         required: true,
       },
     },
     data() {
       return {
       };
     },
   };
</script>
<style scoped>
   @media screen and (max-width: 575px) {
    .home-card {
      height: auto;
      margin-bottom: 40px;
    }
   }
</style>
